<template>
  <div>
    <div class="input-label-error" v-for="(e, i) in lstErros" :key="i">
      <span v-if="mostraErros(e)">{{e.rmesg}}</span>
    </div>
  </div>
</template>

<script>
export default {  
  props: {
    lstErros: Array,
    validador: Object
  },
  data () {
    return {      
    }
  },
  methods: {
    mostraErros(e) {
      return ((this.validador.$dirty && this.validador.$error) || e.rcode != -9901)
    }
  }
 }
</script>
